export default "__VITE_ASSET__B4mSHxaX__"